import React from 'react';
import { Box, Grid } from '@mui/material';
import HeroSection from './Hero';
import ServicesSection from './Services';
import AboutUsSection from './About';
import CertificationsSection from './Certifications';
import FAQSection from './FAQ';
import ContactSection from './Contact';

function App() {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', width: '100vw' }}>
      <Grid container direction="column" spacing={4}>
        <Grid>
          <HeroSection></HeroSection>
        </Grid>
        <Grid>
          <ServicesSection></ServicesSection>
        </Grid>
        <Grid>
          <AboutUsSection></AboutUsSection>
        </Grid>
        <Grid>
          <CertificationsSection></CertificationsSection>
        </Grid>
        <Grid>
          <FAQSection></FAQSection>
        </Grid>
        <Grid>
          <ContactSection></ContactSection>
        </Grid>
      </Grid>
    </Box>
  );
}

export default App;